/*
 * @providesModule SKZConstants
 */

import * as SKZConstants from 'SKZConstantsImplementation';
export default SKZConstants;
